<template>
  <button
    class="tw-flex tw-items-center tw-tracking-normal"
    @click="updateOrderBy"
  >
    <icon-angle-down
      v-if="filters.order_by.replace('-', '') === prop"
      class="tw-mr-2 tw-transition-all tw-transform tw-flxex-1 tw-w-4 tw-h-4"
      :class="{
        'tw-rotate-180': !filters.order_by.includes('-'),
      }"
    />
    {{ title }}
  </button>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    prop: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.foreigners.foreigners.filters,
    }),
  },

  methods: {
    updateOrderBy() {
      if (this.filters.order_by.includes(this.prop)) {
        if (this.filters.order_by.includes('-')) {
          this.$store.commit('v2/admin/foreigners/foreigners/updateFilter', { field: 'order_by', payload: this.prop });
        } else {
          this.$store.commit('v2/admin/foreigners/foreigners/updateFilter', { field: 'order_by', payload: `-${this.prop}` });
        }
      } else {
        this.$store.commit('v2/admin/foreigners/foreigners/updateFilter', { field: 'order_by', payload: this.prop });
      }
    },
  },
};
</script>
